import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";

export const UserList = (props) => {
  const { permissions = [] } = usePermissions();
  console.log("permission is",permissions);
  console.log("props is",props);
  console.log("returning the users")
  return (
    
    <List title="USERS" {...props}>
       <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Users
        </Typography>
      </Box>
      
      <Datagrid
        bulkActionButtons={
          (permissions.includes("users.delete") || permissions.includes("*") || permissions.includes("users.*"))
            ? <BulkDeleteButton />
            :  false
        }
      >
        <TextField source="id" />
        <TextField source="name" />
        <EmailField source="email" />
        
        <TextField source="created_at" />
        <TextField source="created_by" />

        <FunctionField
          label="Action"
          render={() => (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {(permissions.includes("users.*") || permissions.includes("users.edit") || permissions.includes("*")) ? <EditButton />:false}
            </Box>
          )}
        />
      </Datagrid>
    </List>
  );
};

export default UserList;
